import React, { useMemo, useState } from 'react';

import { JDSInputPhoneDropdownProps } from './generated/interface';
import { JDSMenuBlockItemProps } from '../generatedIndex';
import { setPositions } from '../jdsmenublock/positions';
import { useRootRef } from '../../hooks/useRootRef';
import { useToggle } from '../../hooks/useToggle';

interface DropdownMenuItem {
  type?: JDSMenuBlockItemProps['type'];
  label?: string;
  value?: string;
  prefix?: string | JSX.Element;
  suffix?: string | JSX.Element;
  disabled?: boolean;
}

export const withLogic =
  (
    Component: React.ComponentType<JDSInputPhoneDropdownProps>
  ): React.FC<JDSInputPhoneDropdownProps> =>
  (props: JDSInputPhoneDropdownProps) => {
    const { element, rootRef } = useRootRef();
    const { left, top } = useMemo(() => {
      const menuBlockEl = element?.querySelector<HTMLDivElement>(
        'div.j-JDSMenuBlock-container'
      );
      return setPositions(element, menuBlockEl);
    }, [element]);
    const { close, selected, toggle } = useToggle(props.open, true);
    const [selectedItem, setSelectedItem] = useState<
      DropdownMenuItem | undefined
    >(props.items?.[props.selectedIndex || 0]);

    const handleOnSelect = (selectedIndex: number) => {
      const selectedData = props.items?.[selectedIndex];
      toggle();
      setSelectedItem(selectedData);
      props.onSelect?.(selectedIndex, selectedData?.value); // Pass the selected object to onSelect
    };

    return (
      <Component
        {...{
          ...props,
          rootRef,
          _offsetX: left,
          _offsetY: top,
          _maxWidth: 'fit-content',
          open: selected,
          items: props.items,

          countryCode: selectedItem.label,
          countryFlag: selectedItem.prefix,
          onSelect: handleOnSelect,
          onOpen: () => {
            toggle();
            props.onOpen?.();
          },

          onClose: () => {
            close();
            props.onClose?.();
          }
        }}
      />
    );
  };
